import type { SVGProps } from "react";

export const Codesandbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 600 600"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Codesandbox</title>
    <path
      clipRule="evenodd"
      d="M150 150h299.832v300H150V150Zm269.168 30.682v238.636H180.665V180.682h238.503Z"
      fill="#DCFF50"
      fillRule="evenodd"
    />
  </svg>
);

export default Codesandbox;
